import { render, staticRenderFns } from "./selectAlteration.vue?vue&type=template&id=18524335&scoped=true&"
import script from "./selectAlteration.vue?vue&type=script&lang=js&"
export * from "./selectAlteration.vue?vue&type=script&lang=js&"
import style0 from "./selectAlteration.vue?vue&type=style&index=0&id=18524335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18524335",
  null
  
)

export default component.exports